export const _stringify = (param: any): string => {
  return JSON.stringify(param);
};
